import { SxProps } from "@mui/material";

export const sxInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  minWidth: '350px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset',
    minWidth: 'unset'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxTable: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}

export const sxButtonText: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  padding: 0,
  color: '#00834F',
  '&:hover': {
      color: '#164029',
  }
}